export var TagSize;
(function (TagSize) {
    TagSize["small"] = "small";
    TagSize["medium"] = "medium";
    TagSize["large"] = "large";
})(TagSize || (TagSize = {}));
export var TagSkin;
(function (TagSkin) {
    TagSkin["solid"] = "solid";
    TagSkin["light"] = "light";
})(TagSkin || (TagSkin = {}));
//# sourceMappingURL=types.js.map